export default __webpack_public_path__ + "static/media/bg-form-login.9b9522c3.svg";